module.exports = __webpack_public_path__ + "assets/img/schoolIcon.a4a63cc3.png";